<template>
    <div v-if="Object.keys(client).length">
        <div class="row">
            <div class="col card p-3 mx-2">
                <div class="d-flex justify-content-between">
                    <h4>{{ client.name }}{{ client.company_name ? `, ${client.company_name}` : '' }}</h4>
                    <router-link v-if="$store.getters.canEditClients" :to="{name: 'clients.edit', params: {client_id: client.id}}" class="btn btn-primary btn-sm text-white float-right">
                        {{ $t('Edit') }}
                    </router-link>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Name') }}</label>
                            <p class="custom-gray-input-bg">{{ client.name }}</p>
                        </div>
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Drivers license no') }}</label>
                            <p class="custom-gray-input-bg">{{ client.drivers_license }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Id code') }}</label>
                            <p class="custom-gray-input-bg">{{ client.idcode }}</p>
                        </div>
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Id card no') }}</label>
                            <p class="custom-gray-input-bg">{{ client.id_card }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Address') }}</label>
                            <p class="custom-gray-input-bg">{{ client.address }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Phone') }}</label>
                            <p class="custom-gray-input-bg">{{ client.phone }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Email') }}</label>
                            <p class="custom-gray-input-bg">{{ client.email }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Creditcard no') }}</label>
                            <p class="custom-gray-input-bg">{{ client.cc_no }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Creditcard expiry') }}</label>
                            <p class="custom-gray-input-bg">{{ client.cc_validity }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Discount') }} %</label>
                            <p class="custom-gray-input-bg">{{ client.discount_percent }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Comments') }}</label>
                            <p class="custom-gray-input-bg">{{ client.comments }}</p>
                        </div>
                    </div>
                </div>
                <h4 class="mt-3">{{ $t('Company') }}</h4>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Company name') }}</label>
                            <p class="custom-gray-input-bg">{{ client.company_name }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Reg no') }}</label>
                            <p class="custom-gray-input-bg">{{ client.company_reg }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Email') }}</label>
                            <p class="custom-gray-input-bg">{{ client.company_email }}</p>
                        </div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col">
                        <app-checkbox id="newsletter" v-model="client.newsletter" name="newsletter" disabled>
                            {{ $t('Newsletter') }}
                        </app-checkbox>
                        <app-checkbox id="bond" v-model="client.bond" name="bond" disabled>
                            {{ $t('Bond required') }}
                        </app-checkbox>
                        <app-checkbox id="tos" v-model="client.tos" name="tos" rules="required" disabled>
                            {{ $t('Accepted terms') }}
                        </app-checkbox>
                    </div>
                </div>
            </div>
            <div class="col card p-3 mx-2">
                <div class="row">
                    <div class="col">
                        <h4>{{ $t('Rent history') }}</h4>
                    </div>
                </div>
                <div v-if="contracts.length" class="row">
                    <div class="col">
                        <div class="table-responsive">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{{ $t('Pick up & return') }}</th>
                                        <th>{{ $t('Price') }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(contract, i) in contracts" :key="i">
                                        <td>{{ i + 1}}</td>
                                        <td>
                                            {{ contract.vehicle.make.name }} {{ contract.vehicle.model.name }} <app-vehicle-no v-if="contract.vehicle.slug" :slug="contract.vehicle.slug"/>, {{ contract.vehicle.reg_no }} - {{ contract.start_time | formatDateTime }} - {{ contract.end_time | formatDateTime }}
                                        </td>
                                        <td>{{ contract.prices.total / 100 }}€</td>
                                        <td class="p-0 text-right pt-1">
                                            <router-link v-if="$store.getters.canViewContracts" :to="{name: 'contracts.show', params: {contract_id: contract.contract.id}}" class="btn btn-info btn-sm text-white">
                                                {{ $t('View') }}
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientService from '@services/client.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            client: {},
            contracts: [],
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getClient(clientId) {
            ClientService.show(clientId).then(res => {
                this.client = res.client;
                this.contracts = res.contracts;
            });
        },
    },
    components: {
    },
    created() {
        this.getClient(this.$route.params.client_id);
    }
};
</script>
